module.exports = __webpack_public_path__ + "media/images/top/ranking-sample10-ba74d1985065e51f5537b8204de88b19.jpg";